import { Component } from '@angular/core'
import { setLayerControlsVisible } from '../shared/utils/layer-controls-utils'
import { Store } from '@ngrx/store'
import { selectHasMarkers } from '../state/case/case.selectors'
import { Tabs } from '../shared/components/side-panel/side-panel.component'
import { selectionActions } from '../state/selection/selection.actions'
import { SelectionType } from '../state/selection/selection.state'

@Component({
    selector: 'app-case-viewer',
    templateUrl: './case-viewer.component.html',
    styleUrls: ['./case-viewer.component.scss'],
})
export class CaseViewerComponent {
    readonly selectionPanelVisible$ = this.store.select(selectHasMarkers)
    tabToDisplay = Tabs.GATING

    constructor(private readonly store: Store) {}

    layerControlsToggled(visible: boolean): void {
        setLayerControlsVisible(visible)
    }

    changeTab(event: string): void {
        const tab = Tabs[event as keyof typeof Tabs]
        if (tab === Tabs.GATING) {
            this.store.dispatch(selectionActions.setType({ selectionType: SelectionType.Free }))
        }
        if (tab === Tabs.HIERARCHICAL_GATING) {
            this.store.dispatch(
                selectionActions.setType({ selectionType: SelectionType.Hierarchical })
            )
            this.store.dispatch(
                selectionActions.setVisibleSelectionsOnScatterPlot({
                    selectionNames: [],
                })
            )
        }
        if (tab === Tabs.AUTO_CELL_TYPE_DETECTION) {
            this.store.dispatch(
                selectionActions.setType({ selectionType: SelectionType.Unsupervised })
            )
            this.store.dispatch(
                selectionActions.setVisibleSelectionsOnScatterPlot({
                    selectionNames: [],
                })
            )
        }

        this.tabToDisplay = tab
    }

    protected readonly Tabs = Tabs
}
